import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { Image } from "@sparefoot/react-commons";

import sdcRatingIcon from 'assets/icons/sdc.svg';
import googleIcon from 'assets/icons/google.svg';
import { formatCountCompact } from 'utils/helpers';
import Stars from './Stars';
import './StarReview.scss';

function StarReviewV2({
	rating,
	reviewCount,
	outOf,
	className,
	scrollToReviews,
	reviewType,
	formatCompact
}) {
	const displayCount = formatCompact ? formatCountCompact(reviewCount) : reviewCount;

	return (
		<div
			className={classnames(className, 'sdc-star-review')}
			onClick={scrollToReviews}
			onKeyDown={(e) => {
				if (e.key === 'Enter' || e.key === ' ') {
					scrollToReviews();
				}
			}}
			role="button"
			tabIndex={0}
		>

			<div className="sdc-star-review-content">
				<Image
					src={reviewType === 'google' ? googleIcon : sdcRatingIcon}
					alt="Rating Badge"
					className="rating-badge-icon"
				/>
				<div className="sdc-rating-display">
					<Stars
						rating={rating}
						outOf={outOf}
					/>
					<span className="sdc-rating-number">{rating ? rating.toFixed(1) : 0}</span>
				</div>
				<span className="sdc-review-count">
					({displayCount})
				</span>
			</div>
		</div>
	);
}

StarReviewV2.defaultProps = {
	outOf: 5,
	reviewType: 'sparefoot',
	scrollToReviews: () => {},
	formatCompact: false
};

StarReviewV2.propTypes = {
	/** The review rating to render stars for */
	rating: PropTypes.number.isRequired,
	/** Number of reviews */
	reviewCount: PropTypes.number.isRequired,
	/** What the review rating is out of */
	outOf: PropTypes.number,
	reviewType: PropTypes.oneOf(['google', 'sparefoot']),
	className: PropTypes.string,
	scrollToReviews: PropTypes.func,
	/** Whether to format the review count in compact form (e.g., 1.2K, 2M) */
	formatCompact: PropTypes.bool
};

export default StarReviewV2;
